module.exports = __webpack_public_path__ + "static/media/Jon Snow.d06026a7.jpg";